import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import Cookies from 'js-cookie';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import API_PATH from "../../../constants/config.json";
import MidBlockVolumeTab from './VolumeDetails/MidBlockVolumeTab';
import MidBlockClassificationTab from './ClassificationDeatils/MidBlockClassificationTab';
import CircularProgress from '@material-ui/core/CircularProgress';
import MidBlockSpeedTab from './SpeedDetails/MidBlockSpeedTab';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        padding: '0px',
        '& .Mui-selected': {
            background: '#24618E',
            color: "#fff !important",
            fontWeight: '600',
        },
        '& .MuiTabs-root': {
            minHeight: '35px',
        },
        '& .MuiTabs-flexContainer': {
            display: 'inline-block',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: 'transparent !important',
        },
        '& .MuiTab-root': {
            minWidth: '165px',
        },
        '& .PrivateTabIndicator-colorPrimary-14': {
            backgroundColor: '#24618E',
        },
        '& .MuiAppBar-colorDefault': {
            boxShadow: 'none',
            background: '#fff',
            '& .MuiButtonBase-root': {
                border: '1px solid #24618E',
                borderRadius: '6px 6px 0px 0px',
                minHeight: 'auto',
                borderBottom: 'none',
                color: "#333",
                padding: '5px 10px',
            }
        },
        '& h5': {
            fontSize: '16pt',
            margin: '0px',
        }
    },
    mainBlock: {
        padding: '5px',
        height: '100%',
        width: '100%',
        float: 'left',
        background: '#fff',
        top: '2%',
        zIndex: '1',
        '& .MuiPaper-elevation2': {
            boxShadow: 'none',
        },
        '& .focus': {
            background: '#24618E',
            color: "#fff !important",
            fontWeight: '600',
        },
        '& .trafficCountsSelect': {
            padding: '5px',
            color: '#333',
            paddingRight: '20px',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '12pt',
                width: '275px',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '22pt',
                width:'500px',
            },
        }
    }, 
    tabblock: {
        border: '1px solid #24618E',
        paddingTop: '0px',
        marginBottom: '10px',
        borderRadius: '5px 5px 5px 5px',
        width: '100%',
        float: 'left',       
        overflowY: 'scroll',
        '& .MuiBox-root': {
            padding: '0px 10px 10px 10px',
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none !important',
        },
        '& .MuiInput-underline:before': {
            borderBottom: 'none !important',
        },
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
        }
    },
    appBarMain: {
        paddingLeft: '35%',
        marginTop: '-25px',
    },
    tableHead: {
        fontWeight: 'normal',
        textAlign: 'center',
        color: '#333',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    titleTD: {
        textAlign: 'left',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    dataTD: {
        textAlign: 'center',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    tableContent: {
        width: '65%',
    },
    tableSpeedContent: {
        width: '75%',
    },
    tableMidBlock: {
        marginTop: '10px',
        '& td': {
            border: '1px solid #D7D7D7',
            padding: '5px'
        },
        '& th': {
            border: '1px solid #D7D7D7',
            '@media only screen and (max-width: 3500px)': {
                padding: '5px',
            },
            '@media only screen and (min-width: 3501px)': {
                padding: '10px 5px',
            },
        },
        '& tbody.MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)': {
            backgroundColor: ' #f2f2f2 !important',
        },
    },
    tabDivMain: {

    },
    tabDisable: {       
        backgroundColor: '#ffffff',
        color: '#666666',
        border: '1px solid grey',
        opacity: 0.5,
    }
}));
//End Css code ...

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


//Start MidblockTrafficCounts component code ...
const MidblockTrafficCounts = (props) => {
    let activeTab = sessionStorage.getItem('activeMidTrafficCountTab') ? parseInt(sessionStorage.getItem('activeMidTrafficCountTab')) : 0;
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(activeTab);
    const [getCombinedData, setCombinedData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
    const [getNBData, setNBData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
    const [getSBData, setSBData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
    const [getData, setData] = React.useState({});
    const [dateArr, setDateArr] = React.useState([]);
    const [dateVal, setDateVal] = React.useState([]);
    const [selectedDate, setSelectedDate] = React.useState([]);
    const [getResponseData, setResponseData] = React.useState([]);
    const [getVolumeData, setVolumeData] = React.useState(false);
    const [getClassData, setClassData] = React.useState(false);
    const [getSpeedDisable, setSpeedDisable] = React.useState(false);
    const [getSpeedData, setSpeedData] = React.useState([]);
    const [getDirectionName, setDirectionName] = React.useState('');
    const [getDirectionNameTab, setDirectionNameTab] = React.useState('');
    const [getDirectionSpeedName, setDirectionSpeedName] = React.useState('');
    const [getDirectionSpeedCombine, setDirectionSpeedcombine] = React.useState('');
    const [getDirectionSpeedNameTab, setDirectionSpeedNameTab] = React.useState('');
    const [getDirectionClassName, setDirectionClassName] = React.useState('');
    const [getDirectionClassNameTab, setDirectionClassNameTab] = React.useState('');
    const [getLoader,setLoaderDisable] = React.useState(false);


    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]

    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
    useEffect(() => {
        if (props.stationId) {            
            getDateList();
        }
       
    }, [props.stationId]);


    //This method is use for call datelist api for dates ... start
    const getDateList = () => {
        setLoaderDisable(true);
        try {
            axios({
                method: 'post',
                data: {
                    "stationId": props.stationId
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getStationMBCountDateList
            }).then(function (response) {
                if (response && response.data.data && response.data.data.length > 0) {
                    setLoaderDisable(false);
                    let tempArr = [];
                    let tempDateArr = [];
                    setResponseData(response.data.data);
                    response.data.data.map((val) => {
                        tempDateArr.push(val.send_date);
                        tempArr.push(val.date_count);
                    });
                    if(sessionStorage.getItem('midSelectedDate')) {
                        getAllVolumeData(sessionStorage.getItem('midSelectedDate'), response.data.data);
                        getAllSpeedData(sessionStorage.getItem('midSelectedDate'));
                        setSelectedDate(sessionStorage.getItem('midSelectedDate'))
                    } else {
                        getAllVolumeData(tempDateArr[0], response.data.data);
                        getAllSpeedData(tempDateArr[0]);
                        setSelectedDate(tempDateArr[0])
                    }                  
                    setDateVal(tempDateArr);
                    setDateArr(tempArr);
                } else {
                    console.log("");
                    setLoaderDisable(false);
                }
            })
        }
        catch (error) {
            setLoaderDisable(false);           
        }
    }
    //This method is use for call datelist api for dates ... end

    const dateChange = (e) => {
        sessionStorage.setItem('midSelectedDate',e.target.value);
        setSelectedDate(e.target.value);
        getAllVolumeData(e.target.value, getResponseData);
        getAllSpeedData(e.target.value);
    }

    const handleChange = (event, newValue) => {
        sessionStorage.setItem('activeMidTrafficCountTab', newValue);
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        sessionStorage.setItem('activeMidTrafficCountTab', index);
        setValue(index);
    };
   

    //This method is use for call api for midblock volume station details ... start
    const getAllVolumeData = (date = null, data) => {
    setLoaderDisable(true);
        try {
            axios({
                method: 'post',
                data: {
                    "stationId": props.stationId,
                    "dateData": date ? date : selectedDate,
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getstationMBDetail,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setLoaderDisable(false);
                        let resData = data.filter((value, index) => {
                            return value.send_date == date;
                        })
                        disableTab(resData[0]);
                        setData(response.data.data);
                        setCombinedData(response.data.data.dir12.peak);
                        setNBData(response.data.data.dir1.peak);
                        setDirectionName(response.data.data.dir1.direction)
                        setSBData(response.data.data.dir2.peak);
                        setDirectionNameTab(response.data.data.dir2.direction)
                    } else {
                        setLoaderDisable(false);
                        setCombinedData([]);
                        setNBData([]);
                        setSBData([]);
                        setData([]);

                    }
                })
                .catch(function (error) {
                    setLoaderDisable(false);
                    setCombinedData([]);
                    setNBData([]);
                    setSBData([]);
                    setData([]);
                })
        } catch (error) {
            setLoaderDisable(false);
            setCombinedData([]);
            setNBData([]);
            setSBData([]);
            setData([]);
        }
    }
     //This method is use for call api for midblock volume station details ... end

    
     //This method is use for call api for midblock speed station details ... start
     const getAllSpeedData = (date = null) => {
    setLoaderDisable(true);
        try {
            axios({
                method: 'post',
                data: {
                    "stationId": props.stationId,
                    "dateData": date ? date : selectedDate,
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getstationMBSpeedDetail,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setLoaderDisable(false);
                        setSpeedData(response.data.data)
                        setDirectionSpeedName(response.data.data.data1.dir1);
                        setDirectionSpeedcombine(response.data.data.combine.dir12);
                        setDirectionSpeedNameTab(response.data.data.data2.dir2);

                    } else {
                        setLoaderDisable(false);
                        setSpeedData([]);
                    }
                })
                .catch(function (error) {
                    setLoaderDisable(false);                          
                })
        } catch (error) {
            setLoaderDisable(false);
            console.error(error);
        }
    }
    //This method is use for call api for midblock speed station details ... end

    const disableTab = (disableArr) => {
        if (disableArr.class_count === null && disableArr.speed_count === null && disableArr.volume_count === null) {
            setVolumeData(true);
            setClassData(true);
            setSpeedDisable(true);
        } else if (disableArr.class_count === null && (disableArr.speed_count !== null && disableArr.volume_count !== null)) {
            sessionStorage.getItem('activeMidTrafficCountTab') && (sessionStorage.getItem('activeMidTrafficCountTab') == 0 || sessionStorage.getItem('activeMidTrafficCountTab') == 2) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeMidTrafficCountTab'))) : handleChangeIndex(0);
            setVolumeData(false);
            setClassData(true);
            setSpeedDisable(false);
        } else if ((disableArr.class_count !== null && disableArr.speed_count !== null) && disableArr.volume_count === null) {
            sessionStorage.getItem('activeMidTrafficCountTab') && (sessionStorage.getItem('activeMidTrafficCountTab') == 1 || sessionStorage.getItem('activeMidTrafficCountTab') == 2) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeMidTrafficCountTab'))) : handleChangeIndex(1);
            setVolumeData(true);
            setClassData(false);
            setSpeedDisable(false);
        } else if ((disableArr.class_count !== null && disableArr.volume_count !== null) && disableArr.speed_count === null) {
            sessionStorage.getItem('activeMidTrafficCountTab') && (sessionStorage.getItem('activeMidTrafficCountTab') == 0 || sessionStorage.getItem('activeMidTrafficCountTab') == 1) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeMidTrafficCountTab'))) : handleChangeIndex(0);
            setVolumeData(false);
            setClassData(false);
            setSpeedDisable(true);
        }

        else if (disableArr.class_count !== null && (disableArr.speed_count === null && disableArr.volume_count === null)) {
            sessionStorage.getItem('activeMidTrafficCountTab') && (sessionStorage.getItem('activeMidTrafficCountTab') == 1) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeMidTrafficCountTab'))) : handleChangeIndex(1);
            setVolumeData(true);
            setClassData(false);
            setSpeedDisable(true);
        } else if ((disableArr.class_count === null && disableArr.speed_count === null) && disableArr.volume_count !== null) {
            sessionStorage.getItem('activeMidTrafficCountTab') && (sessionStorage.getItem('activeMidTrafficCountTab') == 0) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeMidTrafficCountTab'))) : handleChangeIndex(0);
            setVolumeData(false);
            setClassData(true);
            setSpeedDisable(true);
        } else if ((disableArr.class_count === null && disableArr.volume_count === null) && disableArr.speed_count !== null) {
            sessionStorage.getItem('activeMidTrafficCountTab') && (sessionStorage.getItem('activeMidTrafficCountTab') == 2) ? handleChangeIndex(parseInt(sessionStorage.getItem('activeMidTrafficCountTab'))) : handleChangeIndex(2);
            setVolumeData(true);
            setClassData(true);
            setSpeedDisable(false);
        } else {           
            setVolumeData(false);
            setClassData(false);
            setSpeedDisable(false);
        }
    }

    return (
        <React.Fragment>
            <div className={classes.mainBlock}>
                <p style={{ margin: 0 }}>Count Date &nbsp;
                <select className='trafficCountsSelect'
                        onChange={(e) => dateChange(e)}>
                        {dateArr && dateArr.length > 0 ?
                            dateArr.map((val, index) => {
                                return <option value={ dateVal[index] } selected = {sessionStorage.getItem('midSelectedDate') && sessionStorage.getItem('midSelectedDate') == dateVal[index] ? true : false}>{val}</option>
                            })
                            :
                            <option value=''>{'No data available'}</option>
                        }
                    </select></p>
                <div className={classes.root}>
                    <AppBar position="static" color="default" className={classes.appBarMain}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                        >
                            <Tab className={getVolumeData ? classes.tabDisable : null} label="Volume" {...a11yProps(0)} id="volume_Tab" disabled={getVolumeData} />  
                            <Tab className={getClassData ? classes.tabDisable : null} label="Classification" {...a11yProps(1)} id="classification_tab" disabled={getClassData} />
                            <Tab className={getSpeedDisable ? classes.tabDisable : null} label="Speed" {...a11yProps(2)} id="Speed_tab" disabled={getSpeedDisable} />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        {getLoader == false ? <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock} style={{ height: sessionStorage.getItem('midInnerHeight') + 'px' }}>
                            <TableContainer component={Paper} className={classes.tableContent}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right"></TableCell>
                                            <TableCell align="right" className={classes.tableHead}>AM Peak Hour</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>AM Peak Hour Volume</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>PM Peak Hour</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>PM Peak Hour Volume</TableCell>
                                        </TableRow>
                                    </TableHead>                                    
                                     <TableBody>
                                        <StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD}>Combined</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getCombinedData[0] && getCombinedData.length != 0 ? (getCombinedData[0]['amPeakHour'] ? getCombinedData[0]['amPeakHour'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getCombinedData[0] && getCombinedData.length != 0 ? (typeof(getCombinedData[0]['amPeakVolume']) === "number" ? getCombinedData[0]['amPeakVolume'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getCombinedData[1] && getCombinedData.length != 0 ? (getCombinedData[1]['pmPeakHour'] ? getCombinedData[1]['pmPeakHour'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getCombinedData[1] && getCombinedData.length != 0 ? (typeof(getCombinedData[1]['pmPeakVolume'])  === "number"? getCombinedData[1]['pmPeakVolume'] : '--') : '--'}</TableCell>
                                        </StyledTableRow>
                                        {getDirectionName && <StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD}>{getDirectionName}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getNBData[0] && getNBData.length != 0 ? (getNBData[0]['amPeakHour'] ? getNBData[0]['amPeakHour'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getNBData[0] && getNBData.length != 0 ? (typeof(getNBData[0]['amPeakVolume']) === "number" ? getNBData[0]['amPeakVolume'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getNBData[1] && getNBData.length != 0 ? (getNBData[1]['pmPeakHour'] ? getNBData[1]['pmPeakHour'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getNBData[1] && getNBData.length != 0 ? (typeof(getNBData[1]['pmPeakVolume']) === "number" ? getNBData[1]['pmPeakVolume'] : '--') : '--'}</TableCell>
                                        </StyledTableRow>}
                                        {getDirectionNameTab && <StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD}>{getDirectionNameTab}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSBData[0] && getSBData.length != 0 ? (getSBData[0]['amPeakHour'] ? getSBData[0]['amPeakHour'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSBData[0] && getSBData.length != 0 ? (typeof(getSBData[0]['amPeakVolume']) === "number"  ? getSBData[0]['amPeakVolume'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSBData[1] && getSBData.length != 0 ? (getSBData[1]['pmPeakHour'] ? getSBData[1]['pmPeakHour'] : '--') : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSBData[1] && getSBData.length != 0 ? (typeof(getSBData[1]['pmPeakVolume']) === "number" ? getSBData[1]['pmPeakVolume'] : '--') : '--'}</TableCell>
                                        </StyledTableRow>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className={classes.tabDivMain}>

                                {getData && <MidBlockVolumeTab getData={getData} getDirectionName={getDirectionName} getDirectionNameTab={getDirectionNameTab} />}
                            </div>
                        </TabPanel>:
                         <div style={{textAlign:"center",marginTop:"10%"}}>
                         <span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span>
                       </div>}
                         <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock} style={{ height: sessionStorage.getItem('midInnerHeight') + 'px' }}>
                            <MidBlockClassificationTab selectedDate={selectedDate} stationId={props.stationId} />
                        </TabPanel>
                        {getLoader == false ? <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabblock} style={{ height: sessionStorage.getItem('midInnerHeight') + 'px' }}>
                            <TableContainer component={Paper} className={classes.tableSpeedContent}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right"></TableCell>
                                            <TableCell align="right" className={classes.tableHead}>Posted Speed</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>Average Speed</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>Median Speed</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>Modal Speed</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>85th Percentile</TableCell>
                                        </TableRow>
                                    </TableHead>
                                     <TableBody>
                                        <StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD}>Combined</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.combine && typeof(getSpeedData.combine.tableData.postedSpeed) === "number" ? getSpeedData.combine.tableData.postedSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.combine && typeof(getSpeedData.combine.tableData.averageSpeed) === "number" ? getSpeedData.combine.tableData.averageSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.combine && typeof(getSpeedData.combine.tableData.medianSpeed) === "number" ? getSpeedData.combine.tableData.medianSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.combine && typeof(getSpeedData.combine.tableData.modalSpeed) === "number" ? getSpeedData.combine.tableData.modalSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.combine && typeof(getSpeedData.combine.tableData.eightyFivePercentile) === "number" ? getSpeedData.combine.tableData.eightyFivePercentile : '--'}</TableCell>
                                        </StyledTableRow>
                                        {getDirectionSpeedName && <StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD}>{getDirectionSpeedName}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data1 && typeof(getSpeedData.data1.tableData.postedSpeed) === "number" ? getSpeedData.data1.tableData.postedSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data1 && typeof(getSpeedData.data1.tableData.averageSpeed) === "number" ? getSpeedData.data1.tableData.averageSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data1 && typeof(getSpeedData.data1.tableData.medianSpeed) === "number" ? getSpeedData.data1.tableData.medianSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data1 && typeof(getSpeedData.data1.tableData.modalSpeed) === "number" ? getSpeedData.data1.tableData.modalSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data1 && typeof(getSpeedData.data1.tableData.eightyFivePercentile) === "number" ? getSpeedData.data1.tableData.eightyFivePercentile : '--'}</TableCell>
                                        </StyledTableRow>}
                                        {getDirectionSpeedNameTab && <StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD}>{getDirectionSpeedNameTab}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data2 && typeof(getSpeedData.data2.tableData.postedSpeed) === "number" ? getSpeedData.data2.tableData.postedSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data2 && typeof(getSpeedData.data2.tableData.averageSpeed) === "number" ? getSpeedData.data2.tableData.averageSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data2 && typeof(getSpeedData.data2.tableData.medianSpeed) === "number" ? getSpeedData.data2.tableData.medianSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data2 && typeof(getSpeedData.data2.tableData.modalSpeed) === "number" ? getSpeedData.data2.tableData.modalSpeed : '--'}</TableCell>
                                            <TableCell align="right" className={classes.dataTD}>{getSpeedData.data2 && typeof(getSpeedData.data2.tableData.eightyFivePercentile) === "number" ? getSpeedData.data2.tableData.eightyFivePercentile : '--'}</TableCell>
                                        </StyledTableRow>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className={classes.tabDivMain}>
                                <MidBlockSpeedTab speedData={getSpeedData} getDirectionSpeedName={getDirectionSpeedName} getDirectionSpeedCombine={getDirectionSpeedCombine} getDirectionSpeedNameTab={getDirectionSpeedNameTab} />
                            </div>
                        </TabPanel>:<div style={{textAlign:"center",marginTop:"10%"}}>
                         <span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span>
                       </div>}
                    </SwipeableViews>
                </div>
            </div>
        </React.Fragment>
    );
}

export default MidblockTrafficCounts;
//End MidblockTrafficCounts component code ...